import { css } from '@emotion/css'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Checkbox } from '@mui/material'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import editIcon from '../../../../assets/images/common/edit.svg'

function CustomAccordion({
  defaultOpenState,
  summary,
  children,
  onEdit,
  height,
  preventHandleOpen = false,
  headColor,
  contentPadding,
  withCheckbox = false,
  checkboxAction,
  orderId,
  checkedServiceOrderId,
  setChecked,
  checked,
  arrowIcon,
  openedAccordionIndex,
  setOpenedAccordionIndex,
  index,
  reverseIcon,
  disabled,
  customOpen,
  setCustomOpen,
  disableEditIcon,
  leftIcon,
  backgroundColor,
  isReverse,
  customRotate,
}) {
  useEffect(() => {
    if (setOpenedAccordionIndex) {
      if (openedAccordionIndex === index) {
        setOpen(true)
        setCustomOpen && setCustomOpen(true)
      } else {
        setOpen(false)
        setCustomOpen && setCustomOpen(false)
      }
    }
  }, [openedAccordionIndex])

  const [open, setOpen] = useState(defaultOpenState)

  useEffect(() => {
    if (setChecked && checked !== undefined) {
      if (checkedServiceOrderId === orderId) {
        setChecked(true)
      } else {
        setChecked(false)
      }
    }
  }, [checkedServiceOrderId])

  const handleChange = () => {
    setOpen((open) => !open)
    setCustomOpen && setCustomOpen(!customOpen)

    if (setOpenedAccordionIndex) {
      setOpenedAccordionIndex(index)
    }
  }

  const rotate = setChecked
    ? isReverse
      ? (customOpen ?? open)
        ? 'rotate(0deg)'
        : 'rotate(-90deg)'
      : 'rotate(90deg)'
    : reverseIcon
      ? 'rotate(0deg)'
      : undefined

  const onClick = !disableEditIcon
    ? (e) => {
        e.stopPropagation()
        setOpen(true)
        onEdit()
      }
    : undefined

  const fullCustomRotate = open && customRotate ? customRotate : undefined

  return (
    <Accordion
      expanded={customOpen ?? open}
      onChange={preventHandleOpen ? null : () => handleChange()}
      classes={{
        paper: css({ backgroundColor: '#d5d5d5' }),
        root: css({ margin: '0 !important', boxShadow: 'none !important' }),
      }}
      sx={{
        backgroundColor: headColor ? headColor : '#EDF1F5',
      }}
    >
      <AccordionSummary
        expandIcon={
          arrowIcon ? (
            arrowIcon
          ) : (
            <ExpandMoreIcon
              sx={{
                opacity: disabled ? '0.3' : 1,
              }}
            />
          )
        }
        classes={{
          content: css({
            margin: '4px 0 !important',
          }),
          root: css({
            minHeight: `${height || '48px'} !important`,
            backgroundColor: headColor ? headColor : '#EDF1F5',
            flexDirection: leftIcon ? 'row-reverse' : 'row',
            gap: '12px',
          }),
        }}
        sx={{
          opacity: '1 !important',
          '.MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: fullCustomRotate ?? rotate,
          },
        }}
        disabled={disabled}
      >
        <Box className={'jst-sb aln-center'} width={1}>
          <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>
            {summary}
          </Typography>
          {onEdit || disableEditIcon ? (
            <IconButton
              onClick={onClick}
              disabled={disableEditIcon}
              sx={{ opacity: disableEditIcon ? '0.3' : 1 }}
            >
              <img alt={''} src={editIcon} />
            </IconButton>
          ) : null}
          {withCheckbox && (
            <Checkbox
              checked={checked}
              onClick={(e) => e.stopPropagation()}
              onChange={() => checkboxAction(orderId)}
            />
          )}
        </Box>
      </AccordionSummary>
      <AccordionDetails
        classes={{
          root: css({
            backgroundColor: backgroundColor
              ? backgroundColor
              : '#fff !important',
          }),
        }}
        sx={{ padding: contentPadding }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  )
}

export default observer(CustomAccordion)
